import React, { useState, useEffect } from "react";
import MeasurementsConsumptionComponent from "../../Components/Aton/Measurement/Counter";
import { MedicoesNovoDiv } from "../../Components/Aton/Measurement/styles";

import { ButtonYellow, DivImageHome, HomeDiv, ImageHome } from "./styles";
import { TextH2 } from "../../styles/global.styles";
import { IHealthPlace, IUserLogado } from "../../Services/Interfaces";
import ModalComponentMedicao from "../../Components/Modal/Medicao";
import ModalComponentInfo from "../../Components/Modal/Info";

interface PageHomeProps {
  user: IUserLogado;
  healthPlace: IHealthPlace;
}

const PageHomeConteudo: React.FC<PageHomeProps> = ({ user, healthPlace }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const locationHref = async () => {
    setIsOpen(!modalIsOpen);
  };

  // Função para validar e processar parâmetros da URL
  const validateAndProcessUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const age = urlParams.get('age');
    const height = urlParams.get('height');
    const weight = urlParams.get('weight');
    const gender = urlParams.get('gender');
    const smoking = urlParams.get('smoking');
    const bloodpressuremedication = urlParams.get('bloodpressuremedication');
    const diabetes = urlParams.get('diabetes');

    // Verificar se TODOS os parâmetros de medição estão presentes
    const allParamsPresent = age && height && weight && gender && smoking !== null && bloodpressuremedication !== null && diabetes !== null;

    // Se não há TODOS os parâmetros, não fazer nada (permanecer na home)
    if (!allParamsPresent) {
      return false;
    }

    // Se todos os parâmetros estão presentes, validar valores
    const ageNum = parseInt(age);
    const heightNum = parseInt(height);
    const weightNum = parseInt(weight);
    
    if (ageNum >= 13 && ageNum <= 120 && 
        heightNum >= 68 && heightNum <= 290 && 
        weightNum >= 25 && weightNum <= 199 &&
        ['male', 'female'].includes(gender) &&
        ['0', '1'].includes(smoking) &&
        ['0', '1'].includes(bloodpressuremedication) &&
        ['0', 'type1', 'type2'].includes(diabetes)) {
      
      // Se todos os dados são válidos, executar medição diretamente
      if (healthPlace && healthPlace.limitPerMonth >= healthPlace.usedCurrentMonth) {
        // Mostrar loader e executar medição diretamente
        setIsLoading(true);
        executeMeasurementDirectly(age, height, weight, gender, smoking, bloodpressuremedication, diabetes);
        return true;
      }
    } else {
      // Se algum parâmetro é inválido, abrir modal para correção
      if (healthPlace && healthPlace.limitPerMonth >= healthPlace.usedCurrentMonth) {
        setIsOpen(true);
        return true;
      }
    }
    
    return false;
  };

  // Função para executar medição diretamente sem abrir modal
  const executeMeasurementDirectly = async (age: string, height: string, weight: string, gender: string, smoking: string, bloodpressuremedication: string, diabetes: string) => {
    try {
      const HealthPlaceJSON = localStorage.getItem("HealthPlaceDados");
      if (HealthPlaceJSON) {
        const HealthPlaceDados = JSON.parse(HealthPlaceJSON);
        const customer = HealthPlaceDados.customer.deepAffexCallbackId;
        const service = HealthPlaceDados.service.deepAffexCallbackId;
        
        const { linkDeepaffex } = await import("../../Services/Auth");
        const path = await linkDeepaffex(
          JSON.stringify({
            identifier: `${customer}--${service}`,
            age,
            height,
            weight,
            gender,
            smoking,
            bloodpressuremedication,
            diabetes,
          })
        );
        if (path) {
          window.location.href = path.toString();
        }
      }
    } catch (error) {
      console.error('Erro ao executar medição:', error);
      setIsLoading(false);
    }
  };

  // Verificar parâmetros da URL ao carregar o componente
  useEffect(() => {
    validateAndProcessUrlParams();
  }, [healthPlace]);

  // Se estiver carregando, mostrar apenas o loader
  if (isLoading) {
    return (
      <HomeDiv style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loader" style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #6257b8',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <TextH2 style={{ color: '#6257b8' }}>Iniciando medição...</TextH2>
          <p style={{ color: '#666', marginTop: '10px' }}>Aguarde enquanto preparamos sua medição</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </HomeDiv>
    );
  }

  return (
    <HomeDiv>
      <TextH2>Olá, {`${user.profile.fullName}`} 👋</TextH2>
      <br />
      <MeasurementsConsumptionComponent
        total={healthPlace.limitPerMonth}
        restante={healthPlace.usedCurrentMonth}
      />
      <br />
      <br />
      <TextH2>Informações para a Medição</TextH2>
      <br />
      <DivImageHome>
        <ImageHome
          src={"/InformacoesparaaMedicao.png"}
          alt="Informações para a Medição"
        />
      </DivImageHome>
      <br />
      <MedicoesNovoDiv>
        <ModalComponentMedicao
          setIsOpen={setIsOpen}
          modalIsOpen={modalIsOpen}
        />
        <ModalComponentInfo
          setStartMeasure={locationHref}
          setIsOpen={setIsInfoModalOpen}
          isOpen={isInfoModalOpen}
        />
        <ButtonYellow
          onClick={() => {
            healthPlace &&
            healthPlace.limitPerMonth >= healthPlace.usedCurrentMonth
              ? setIsInfoModalOpen(true)
              : setIsInfoModalOpen(false);
          }}
        >
          {healthPlace &&
          healthPlace.limitPerMonth >= healthPlace.usedCurrentMonth
            ? "Iniciar nova medição"
            : "Você já realizou todas as medições disponíveis"}
        </ButtonYellow>
      </MedicoesNovoDiv>
    </HomeDiv>
  );
};

export default PageHomeConteudo;
